import axiosInstance from '../../../config/axiosInstance';
const CustomerContactService = {
    async GetAllCustomerContacts(redirectCallback, ClientCompanyID) {
        try {

            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Customer/GetCustomerContacts?ClientCompanyID=${ClientCompanyID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async GetAllNewCustomerContacts(redirectCallback, ClientCompanyID, Start, PageSize, searchQuery, sortColumn, sortDirection, EmailingName = "", SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/GetAllNewCustomerContacts?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async GetCustomerContactCount(redirectCallback, ClientCompanyID, searchQuery, EmailingName = "", SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/GetCustomerContactCount?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}&searchQuery=${searchQuery}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },



    async GetContactByBranch(redirectCallback, BranchID) {
        try {

            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Customer/GetContactByBranch?BranchID=${BranchID}&ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetCustomerContactByID(redirectCallback, ClientContactID) {
        try {
            const response = await axiosInstance.get(`/Customer/GetCustomerContactByID?ID=${ClientContactID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteCustomerContact(ID, redirectCallback) {
        try {
            const idString = ID.join(',');
            const response = await axiosInstance.get(`/Customer/DeleteCustomerContact?ID=${idString}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async LockContact(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Customer/LockContact?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UnLockContact(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Customer/UnLockContact?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async AllNewSiteContact(ClientBranchID, Start, PageSize, searchQuery, sortColumn, sortDirection, EmailingName = "", SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/AllNewSiteContact?ClientID=${ClientID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}&ClientBranchID=${ClientBranchID}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async CustomerContactCountByBranch(ClientBranchID, searchQuery, EmailingName = "", SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/CustomerContactCountByBranch?ClientID=${ClientID}&ClientBranchID=${ClientBranchID}&searchQuery=${searchQuery}&UserID=${UserID}&EmailingName=${EmailingName}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },
};

export default CustomerContactService;